import React from 'react';
import { verificationRequest } from './phoneVerificationService.js';
export default function usePhoneVerificationCapabilities(phone) {
  const [snapshot, setSnapshot] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    setSnapshot(null);
    if (phone) verificationRequest('capabilities', { phone }).then(data => {
      if (alive) setSnapshot({ phone, ...data.capabilities });
    }).catch(() => { if (alive) setSnapshot({ phone, channels: [] }); });
    return () => { alive = false; };
  }, [phone]);
  return snapshot?.phone === phone ? snapshot : null;
}
